import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-budget-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
    imports: [
      CommonModule,
      MatCardModule,
      MatIconModule
    ]
})
export class BudgetStatusComponent {
  // Inputs for both validations
  @Input() projectApprovedAmount: number = 0; // For budget validation
  @Input() totalCostsRequested: number = 0;   // Common input
  @Input() totalCostsActual: number = 0;        // For plan validation
  @Input() totalFundingFromOtherSources: number = 0; // For plan validation

  // When both validations fail, allow toggling between them.
  // By default, the plan validation view is active.
  currentValidation: 'plan' | 'budget' = 'plan';

  // Computed property for budget validation
  get budgetDifference(): number {
    return this.projectApprovedAmount - this.totalCostsRequested;
  }
  get isBudgetInSync(): boolean {
    return this.budgetDifference === 0;
  }

  // Computed property for plan validation
  get planDifference(): number {
    return this.totalCostsActual - (this.totalCostsRequested + this.totalFundingFromOtherSources);
  }
  get isPlanInSync(): boolean {
    return this.planDifference === 0;
  }
  get isPlanShort(): boolean {
    return this.planDifference > 0;
  }
  get isPlanOver(): boolean {
    return this.planDifference < 0;
  }

  // Returns true if both validations are unsynced
  hasMultipleErrors(): boolean {
    return !this.isPlanInSync && !this.isBudgetInSync;
  }

  // Decide which validation view to show.
  // If both validations are unsynced, use the currentValidation flag.
  shouldShowPlanValidation(): boolean {
    if (!this.isPlanInSync && this.currentValidation === 'plan') {
      return true;
    }
    return false;
  }

  // Toggle between the two validation views.
  toggleValidation(): void {
    this.currentValidation = this.currentValidation === 'plan' ? 'budget' : 'plan';
  }
}
